//import 'ol/ol.css';
import { INode, FeatureType, ICAMSKey, OrderDirection, IAPIResult, IMapInteractionConfig, TextPack } from '../Shared/Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities, ModalAction } from '../Shared/Utility/Utilities';
import { SubmissionList } from './SubmissionList';
import * as events from '../Shared/Bus/Bus';
import { MapLayerGroupType } from '../Shared/Models/MapConfigModels';
import { CAMSMap } from '../Extensions/CAMSOLExtensions';
import { IssueNotificationType } from '../Shared/Maint/MaintModels';

enum jqc {
    placeholder_for_modals = '#placeholder-for-modals',

    maintMergeModal = '#maintMergeModal',
    submissionsMerge_CloseBtn = '#submissionsMerge_CloseBtn',
    submissionsMerge_SaveBtn = '#submissionsMerge_SaveBtn',
    submissionsMerge_CancelBtn = '#submissionsMerge_CancelBtn',
    submissionsMerge_Message1 = '#submissionsMerge_Message1',
    submissionsMerge_Message2 = '#submissionsMerge_Message2',
    submissionsMergePanel = '#submissionsMergePanel',
    maintMergeSubmitBtn = '#maintMergeSubmitBtn',
    maintMergeForm = '#maintMergeForm',
    maintMergeCancelBtn = '#maintMergeCancelBtn'
}

export class SubmissionList_Merge {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private newMergeWizardState: { fromCAMSKey?: ICAMSKey, toCAMSKey?: ICAMSKey };
    private subscriptionSingleFeatureSelected;

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor(protected map: CAMSMap, protected SubmissionList: SubmissionList) {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;

        Utilities.GetControl(jqc.submissionsMerge_CloseBtn).on('click', function () { self.mergeWizard_Close() });
        Utilities.GetControl(jqc.submissionsMerge_SaveBtn).on('click', function () { self.mergeWizard_Save() });
        Utilities.GetControl(jqc.submissionsMerge_CancelBtn).on('click', function () { self.mergeWizard_Cancel() });
    }

    // ----------------------------------------------------------- //
    // PUBLIC Functions
    public openMergePanel = (fromCAMSKey: ICAMSKey, toCAMSKey: ICAMSKey): void => {
        const self = this;
        Utilities.BlockUI();
        $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME +'/Maint/IssueMergeView', { fromMaintCode: fromCAMSKey.code, toMaintCode: toCAMSKey.code }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            // Create modal
            Utilities.GetModal(jqc.maintMergeModal, ModalAction.Create);
            Utilities.GetControl(jqc.maintMergeSubmitBtn).on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = Utilities.GetControl(jqc.maintMergeForm);
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI();
                let formData = new FormData(<any>Utilities.GetControl(jqc.maintMergeForm)[0]);

                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Maint/MergeIssue',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Issue merged!');
                                events.bus.publish(events.eventRefreshMapLayer(FeatureType.Maint));
                                Utilities.GetModal(jqc.maintMergeModal, ModalAction.Hide);

                                // Zoom to issue
                                events.bus.publish(events.eventZoomToAnyFeature([toCAMSKey, true, null]));

                                self.SubmissionList.openSubmissionIssueResponseForm(toCAMSKey.code, IssueNotificationType.Merged, fromCAMSKey.code);
                            }
                            else {
                                if (result.message != null) toastr.error(result.message);
                                else toastr.error('Failed to merge issue!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI();
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            Utilities.GetControl(jqc.maintMergeCancelBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.maintMergeModal, ModalAction.Hide);
            });
        });
    }

    // ----------------------------------------------------------- //
    // New Maint WIZARD
    public mergeWizard_Start = (data: ICAMSKey): void => {
        const self = this;

        // Make sure the various layers are turned on
        events.bus.publish(events.eventMapLayerVisibilitySwitch([MapLayerGroupType.MyMaint, true]));
        events.bus.publish(events.eventMapLayerVisibilitySwitch([MapLayerGroupType.Maint, true]));

        // Zoom to issue
        events.bus.publish(events.eventZoomToAnyFeature([data, true, null]));

        // Reset everything
        self.newMergeWizardState = { fromCAMSKey: data };
        Utilities.GetControl(jqc.submissionsMerge_Message1).show();
        Utilities.GetControl(jqc.submissionsMerge_Message2).hide();
        Utilities.GetControl(jqc.submissionsMerge_SaveBtn).hide();
        Utilities.GetControl(jqc.submissionsMergePanel).addClass('show');
        if (self.subscriptionSingleFeatureSelected) self.subscriptionSingleFeatureSelected();

        // STEP 1: Select Geom
        let interactionData: IMapInteractionConfig = { zoomToSelectedFeatures: false, addToExistingSelection: false, selectableLayers: [FeatureType.Maint] };
        events.bus.publish(events.eventStartSingleSelection(interactionData))

        self.subscriptionSingleFeatureSelected = events.bus.subscribe(events.eventSingleFeatureSelected, m => {
            self.subscriptionSingleFeatureSelected();
            self.newMergeWizardState.toCAMSKey = self.map.convertFeatureToCAMSKey(m.payload);

            $('#submissionsMerge_Message1').hide();
            $('#submissionsMerge_Message2').show();
            $('#submissionsMerge_SaveBtn').show();
        });
    }

    private mergeWizard_Save = (): void => {
        this.openMergePanel(this.newMergeWizardState.fromCAMSKey, this.newMergeWizardState.toCAMSKey);
        this.mergeWizard_Cancel();
    }

    private mergeWizard_Close = (): void => {
        this.mergeWizard_Cancel();
    }

    private mergeWizard_Cancel = (): void => {
        events.bus.publish(events.eventRemoveAllMapInteractions());
        events.bus.publish(events.eventClearAllHighlights());
        events.bus.publish(events.eventClearSelectedFeatures());
        events.bus.publish(events.eventResetAllPanels());
        if (this.subscriptionSingleFeatureSelected) this.subscriptionSingleFeatureSelected();
    }

}




